/**
 * تبدیل اعداد انگلیسی به فارسی
 */
export const toPersianNumber = (num: number | string): string => {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return num.toString().split('').map(digit => {
    if (digit >= '0' && digit <= '9') {
      return persianDigits[parseInt(digit)];
    }
    return digit;
  }).join('');
};

/**
 * تبدیل اعداد فارسی به انگلیسی
 * پشتیبانی از اعداد فارسی، عربی و انگلیسی
 * همچنین حذف کاراکترهای غیرعددی (مثل فاصله‌های خاص iOS)
 */
export const toEnglishNumber = (str: string): string => {
  // نرمال‌سازی یونیکد برای iOS
  const normalized = str.normalize('NFKC');
  
  // تبدیل با regex - پشتیبانی از همه انواع اعداد فارسی/عربی
  return normalized
    // اعداد فارسی (۰-۹)
    .replace(/[۰-۹]/g, (char) => String(char.charCodeAt(0) - 0x06F0))
    // اعداد عربی (٠-٩)
    .replace(/[٠-٩]/g, (char) => String(char.charCodeAt(0) - 0x0660))
    // حذف هر کاراکتر غیرعددی (فاصله، نقطه و غیره)
    .replace(/[^\d]/g, '');
};
